<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">{{__('Products')}}</h1>
    <div class="mb-6 justify-between items-center topFilterBar">
      <div style="margin-bottom: inherit;">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
          <label class="block text-gray-700">Trashed:</label>
          <select v-model="form.trashed" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="with">With Trashed</option>
            <option value="only">Only Trashed</option>
          </select>
        </search-filter>
      </div>
      <div style="white-space: nowrap;margin-bottom: inherit;">
        <span v-if="gridView" v-on:click="gridView = !gridView" class="pointer" style="margin-bottom: -10px;" >
          <icon name="list" class="block w-9 h-8 fill-indigo-600" />
        </span>
        <span v-else v-on:click="gridView = !gridView" class="pointer" style="margin-bottom: -10px;" >
          <icon name="grid" class="block w-9 h-8 fill-indigo-600" />
        </span>
        <inertia-link class="btn-indigo" :href="route('labels.create')" v-if="$page.props.auth.user.owner">
          <span>Upload</span>
          <span class="hidden md:inline">Label</span>
        </inertia-link>
      </div>
    </div>

    <!-- grid veiw -->
     <div class="bg-white rounded-md shadow gridView" v-if="gridView">
        <div class="cards" style="float:left;" v-for="labelT in labels.data" :key="labelT.id" 
        :style="{ backgroundImage:`url(/storageThumbnail/${labelT.thumbnail_path})`, backgroundSize: `75% auto`, backgroundPositionY: `5px`}"
        v-bind:class = "[labelT.price_per_1k < 0.5 ?'inactive':'',(labelT.id > 0 && labelT.id < 7) ?'custbg':(labelT.id == 0 ? 'custbg60':'')]">
          <p style="background: white; padding: 5px;">
            <ul>
              <!-- <li class="p-1" v-if="labelT.price_per_1k > -1">{{ labelT.label_name }} ({{ labelT.price_per_1k }}€/{{ labelT.unit }})</li> -->
              <!-- <li class="p-1" v-else>{{ labelT.label_name | subStr }} (Approval Pending) </li> -->
              <li class="p-1">{{ labelT.label_name }}</li> <li> ({{labelT.price_per_1k }}€/{{ labelT.unit }})</li>
              <!-- <li class="p-1">{{ labelT.organization.name }}</li> -->
            </ul>
          </p>
          <!-- <div class="bottom-bar">
               <a :href="'/storageFile/'+labelT.file_path" target="_blank" title="View Label File" >
                <icon name="view" class="block w-6 h-6 fill-indigo-400" />
              </a>
              <inertia-link v-if="$page.props.auth.user.owner" class="pl-4 flex items-center focus:text-white-500" style="float:left;" :href="route('labels.edit', labelT.id)">
                <icon name="edit" class="block w-6 h-5 fill-indigo-400" />
              </inertia-link>
              <button v-if="!labelT.deleted_at && $page.props.auth.user.owner" class="pl-2 text-red-600 hover:underline" style="float:left;" tabindex="-1" type="button" @click="destroy(labelT.id)">
                <icon name="cross" class="block w-6 h-6 fill-red-400" />
              </button>
          </div> -->
        </div>
     </div>

    <!-- list view -->
    <div class="bg-white rounded-md shadow overflow-x-auto" v-if="!gridView">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Customer</th>
          <th class="px-6 pt-6 pb-4">Label Name</th>
          <th class="px-6 pt-6 pb-4" v-if="$page.props.auth.user.owner">Prod. No CERM</th>
          <th class="px-6 pt-6 pb-4" v-if="$page.props.auth.user.customer_id > 0">Label No</th>
          <th class="px-6 pt-6 pb-4" v-if="$page.props.auth.user.owner">Ref. Calc. CERM</th>
          <th class="px-6 pt-6 pb-4">Price Per 1000</th>
          <th class="px-6 pt-6 pb-4">File</th>
          <th class="px-6 pt-6 pb-4" v-if="$page.props.auth.user.owner">Action</th>
        </tr>
        <tr v-for="label in labels.data" :key="label.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 pt-6 pb-4">
              {{ label.organization.name }}
           </td>
          <td class="border-t px-6 pt-6 pb-4">
              {{ label.label_name }}
           </td>
           <td class="border-t px-6 pt-6 pb-4">
              {{ label.prod_no_cerm }}
           </td>
           <td class="border-t px-6 pt-6 pb-4" v-if="$page.props.auth.user.owner">
              {{ label.ref_cacl_cerm}}
           </td>
          <td class="border-t pl-2per">
              {{label.price_per_1k}} €
           </td>
           <td class="border-t pl-2per">
              <a :href="'/storageFile/'+label.file_path" target="_blank" title="View Label File" v-if="label.price_per_1k > 0">
                <icon name="view" class="block w-6 h-6 fill-indigo-400" />
              </a>
              <a :href="'/storageFile/'+label.file_path" target="_blank" title="View Label File" v-else>
                <icon name="view" class="block w-6 h-6 fill-indigo-400" /> (Approval Pending)
              </a>
           </td>
           <td class="border-t pl-2per" v-if="$page.props.auth.user.owner">
            <button v-if="!label.deleted_at" class="text-red-600 hover:underline" style="float:left;" tabindex="-1" type="button" @click="destroy(label.id)">
              <icon name="cross" class="block w-6 h-6 fill-red-400" />
            </button>
             <inertia-link v-if="$page.props.auth.user.owner" class="pl-4 flex items-center focus:text-indigo-500" style="float:left;" :href="route('labels.edit', label.id)">
              <icon name="edit" class="block w-6 h-6 fill-indigo-400" />
             </inertia-link>
           </td>
        </tr>
        <tr v-if="labels.data.length === 0">
          <td class="border-t px-6 py-4" colspan="6">No labels found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="labels.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Labels' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    labels: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      gridView: true
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('label-list'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  mounted(){
    // console.log(this.labels)
  },
  filters: {
  	subStr: function(string) {
        if(string.length > 12){
          return string.substring(0,12) + '..'
        }else{
          return string
        }
      }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(label_id) {
      if (confirm('Are you sure you want to delete this Label?')) {
        this.$inertia.delete(this.route('labels.destroy', label_id))
      }
    },
  },
}
</script>
<style scoped>
.pl-2per{
  padding-left: 2%;
}
.topFilterBar{
  display: flex;
}
.pointer{
  margin-right:4%;
  display: inline-block;
}
span.pointer {
  cursor: pointer;
}
.cards{
  width:215px;
  height:240px;
  background:#fff;
  margin:20px;
  border-radius:0.375rem;
  /* box-shadow:0px 0px 15px 0px #313131; */
  border: 1.5px solid #e2e8f0;
  background-size:102%;
  background-repeat:no-repeat;
  background-position:top center;
  position:relative;
  overflow:hidden;
}
.bottom-bar{
  width:100%;
  height:45px;
  position:absolute;
  bottom:-100%;
  background:#fff;
  transition:all 0.3s;
  text-align:center;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:99;
  border-top:1px solid #3333;
}
.cards:hover .bottom-bar{
  bottom:0px;
}
.cards a{
  cursor:pointer;
  padding:5px 10px;
  border-radius:4px;
  color:whitesmoke;
}
.cards a:hover{
  background:#3333;
  color:white;
}
.cards p{
  text-align:center;
  position:absolute;
  width:100%;
  bottom:5px;
  /* font-size:18px; */
  color:#39415a;
}
.gridView{
    display: flow-root;
    margin-bottom: 3%;
  }
 .inactive{
   opacity: 0.6;
   filter: grayscale(100%);
 }
 .custbg{
  background-size: 92% auto !important;
 }
 .custbg60{
  background-size: 60% auto !important;
 }
/******************RESPONSIVE***********************/
@media screen and (max-width:500px){
  .topFilterBar{
    display: block;
  }
  .gridView{
    display: grid;
    justify-content: center;
  }
  .cards{
    margin:15px 5px;
    width:215px;
    height:240px;
  }
  .bottom-bar{
    height:46px;
  }
}
</style>
